import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'dva';
import SidebarBody from '../SidebarBody';

function HelpContent(props) {
  return (
    <SidebarBody>
      <div>help placeholder</div>
    </SidebarBody>
  );
}


HelpContent.propTypes = {

};

export default connect((model)=>{
  return {
  };
})(HelpContent);
